import { createAsyncAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { Failure, Request, Success } from './types'

export const createNewGroupAction = createAsyncAction(
  '@chat/CREATE_NEW_GROUP_REQUEST',
  '@chat/CREATE_NEW_GROUP_SUCCESS',
  '@chat/CREATE_NEW_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingCreateNewGroup: true,
  isErrorOnCreateNewGroup: false
})

const success = (state: ChatState): ChatState => ({
  ...state,
  isLoadingCreateNewGroup: false,
  isErrorOnCreateNewGroup: false
})
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingCreateNewGroup: false,
  isErrorOnCreateNewGroup: true
})

export const createNewGroupHandle = { asyncAction: createNewGroupAction, request, success, failure }
